import { Toaster } from 'sonner';
import { useThemeStore } from '@/store';
import type { ReactNode } from 'react';

export function ToastProvider({ children }: { children: ReactNode }) {
  const resolvedTheme = useThemeStore((s) => s.resolvedTheme);

  return (
    <>
      {children}
      <Toaster
        theme={resolvedTheme}
        position="bottom-right"
        toastOptions={{
          duration: 4000,
          style: {
            borderRadius: '12px',
          },
        }}
      />
    </>
  );
}
